module.exports = __webpack_public_path__ + "pc/img/award2021_02.81731856.png";